export const c_login__main_footer_links_item_link_svg_Fill = {
  "name": "--pf-c-login__main-footer-links-item-link-svg--Fill",
  "value": "#6a6e73",
  "var": "var(--pf-c-login__main-footer-links-item-link-svg--Fill)"
};
export default c_login__main_footer_links_item_link_svg_Fill;